const boj_link = "https://www.acmicpc.net/problem/"

export default [
  {
    'site' : 'BOJ',
    'number': '7569',
    'name' : '토마토',
    'disc' : '익은 토마토 찾아내기',
    'type' : 'DFS , BFS',
    'date' : '2019.01',
    'link' : boj_link + '7569',
  },
  {
    'site' : 'SWexpert',
    'number': '5644',
    'name' : '[모의 Test] 무선충전',
    'disc' : '최적의 Battery Charger를 선택하는 알고리즘',
    'type' : 'Simulation',
    'date' : '2019.01',
    'link' : 'https://swexpertacademy.com/main/code/problem/problemDetail.do?contestProbId=AWXRDL1aeugDFAUo&categoryId=AWXRDL1aeugDFAUo&categoryType=CODE',
  },
  {
    'site' : 'BOJ',
    'number': '11559',
    'name' : '뿌요뿌요',
    'disc' : '연쇄가 몇 번 연속으로 일어날지 계산',
    'type' : 'DFS, BFS',
    'date' : '2019.01',
    'link' : boj_link + '11559'
  },
  {
    'site' : 'BOJ',
    'number': '17070',
    'name' : '파이프 옮기기 1',
    'disc' : ' 한쪽 끝을 (N, N)으로 이동시키는 방법의 수를 출력',
    'type' : 'DFS',
    'date' : '2019.01',
    'link' : boj_link + '17070'
  },
  {
    'site' : 'SWexpert',
    'number': '5656',
    'name' : '[모의 Test] 벽돌깨기',
    'disc' : '구슬을 N번 쏘았을 때 남은 벽돌의 갯수는?',
    'type' : 'Simulation',
    'date' : '2019.01',
    'link' : 'https://swexpertacademy.com/main/code/problem/problemDetail.do?contestProbId=AWXRQm6qfL0DFAUo&categoryId=AWXRQm6qfL0DFAUo&categoryType=CODE',
  },
  {
    'site' : 'Programmers',
    'number': '17679',
    'name' : '[2017 kakako 1차] 프렌즈4블록',
    'disc' : '블록깨기',
    'type' : 'Simulation',
    'date' : '2019.09',
    'link' : 'https://ini080.github.io/algorithm/2019/09/03/algo-prog-kakao1%EC%B0%A8-%ED%94%84%EB%A0%8C%EC%A6%884%EB%B8%94%EB%A1%9D/',
  },
  {
    'site' : 'Programmers',
    'number': '42889',
    'name' : '[2017 kakako 1차] 실패율',
    'disc' : '실패율 구하기',
    'type' : 'Simulation',
    'date' : '2019.09',
    'link' : 'https://ini080.github.io/algorithm/2019/09/03/algo-prog-kakao1%EC%B0%A8-%EC%8B%A4%ED%8C%A8%EC%9C%A8/',
    },
    {
      'site' : 'Programmers',
      'number': '42889',
      'name' : '[2017 kakako 1차] 뉴스클러스터링',
      'disc' : '합집합,교집합 구해서 계산하기',
      'type' : 'Simulation',
      'date' : '2019.09',
      'link' : 'https://ini080.github.io/algorithm/2019/09/03/algo-prog-kakao1%EC%B0%A8-%EB%89%B4%EC%8A%A4%ED%81%B4%EB%9F%AC%EC%8A%A4%ED%84%B0%EB%A7%81/',
      },
]
